import { render } from "./_tag-card.vue?vue&type=template&id=194899b8&lang=pug"
import script from "./_tag-card.vue?vue&type=script&setup=true&lang=js"
export * from "./_tag-card.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__